<template>
	<div class="container">
		<estrella v-for="(i, index) in 5" :key="`fija-${index}`"></estrella>
		<estrella-fugaz
			v-for="(i, index) in 3"
			:key="`fugaz-${index}`"
		></estrella-fugaz>
		<img class="logo-cpe" src="@/assets/img/splash_screen/CPE.png" alt="CPE" />
		<div class="volver-container">
			<div class="planeta-volver">
				<img
					src="@/assets/img/planetas/planeta_volver.png"
					alt=""
					class="planeta"
					@click="volver"
				/>
				<div class="tooltip">
					<span>{{textoVolver}}</span>
				</div>
			</div>
			<div class="titulo">
				<h1>{{titulo}}</h1>
			</div>
		</div>
		<div v-if="filtro == null" class="leyenda">
			<h1>{{texto}}</h1>
		</div>
		<div class="apps-container">
			<div class="observatorio">
				<img
					class="observatorio-img"
					src="@/assets/img/docentes_screen/observatorio.png"
					alt=""
				/>
			</div>
			<h1 class="filtro">{{ filtro }}</h1>
			<div class="apps-lista scroll-light" @click="test">
				<div class="shuffle-lista">
					<div
						v-for="contenido in contenidos"
						:key="contenido.id"
						:data-groups="`[&quot;${contenido.tipo_recurso}&quot;]`"
						class="app-item"
					>
						<div class="icono" @click="open(contenido)">
							<img
								:src="
									require(`@/assets/img/contenidos_icons/${
										contenido.icono ? contenido.icono : 'default.png'
									}`)
								"
								alt=""
							/>
						</div>
						<div class="texto">
							<span class="textoin">{{ contenido.nombre }}</span>
						</div>
						<div v-if="contenido.guia" class="botonguia btn btn-default" @click="verGuia(contenido)">ver guía</div>
					</div>
				</div>
			</div>
		</div>
		<div class="selectores">
			<div v-for="tipo in tipo_recursos" :key="tipo" class="selector">
				<div class="circulo" @click="filtrar(tipo)">
					<h2>{{ tipo[0] }}</h2>
				</div>
				<div class="titulo">
					<span>{{ tipo }}</span>
				</div>
			</div>
		</div>
		<side-bar-menu
			:bgcolor="'#1d70b7 '"
			:eventBus="eventBus"
			:contenidos="
				contenido_seleccionado ? contenido_seleccionado.contenidos : []
			"
		/>
		<visor-guia
			:eventBus="eventBus"
			:contenido_seleccionado="contenido_seleccionado"
		/>
	</div>
</template>
<script>

import Vue from 'vue'
import isElectron from 'is-electron'

import Estrella from '@/components/Estrella.vue'
import EstrellaFugaz from '@/components/EstrellaFugaz.vue'
import SideBarMenu from '@/components/SideBarMenu.vue'
import VisorGuia from '@/components/VisorGuia.vue'

import Shuffle from 'shufflejs'
var shuffleInstance

export default {
	name: 'docentes',
	components: {
		Estrella,
		EstrellaFugaz,
		SideBarMenu,
		VisorGuia
	},
	data: function () {
		return {
			contenido_seleccionado: null,
			filtro: null,
			eventBus: new Vue()
		}
	},
	computed: {
		textoVolver(){
			return this.$store.getters.tooltips.volver;
		},
		titulo(){
			return this.$store.getters.docentesScreen.titulo;
		},
		texto(){
			return this.$store.getters.docentesScreen.textoInicial;
		},
		tipo_recursos () {
			return this.$store.getters.tiposRecursosDocente;
		},
		contenidos () {
			return this.$store.getters.contenidosDocente;
		}
	},
	methods: {
		volver () {
			// this.$router.go(-1);
			this.$router.replace({name: 'home'});
		},
		test () {

		},
		filtrar (item) {
			console.log(item);
			this.filtro = item;
		},
		open (contenido) {
			if (isElectron()) {
				if (contenido.contenidos) {
					this.contenido_seleccionado = contenido;
					this.eventBus.$emit('abrirMenu');
				} else {
					const { shell } = require('electron');
					// shell.openItem(contenido.ruta);
					shell.openExternal(contenido.ruta);
					console.log(contenido.ruta);
				}
			}else{
				let win = window.open(contenido.ruta_web, '_blank');
				win.focus();
			}
		},
		verGuia (contenido) {
			this.contenido_seleccionado = contenido;
			setTimeout(() => {
				this.eventBus.$emit('abrirGuia');
			}, 100);
		}
	},
	created () {

	},
	mounted () {
		var element = document.querySelector('.shuffle-lista');
		shuffleInstance = new Shuffle(element, {
			itemSelector: '.app-item',
			sizer: '.app-item',
			speed: 500,
			throttleTime: 500
		});
		shuffleInstance.filter([this.filtro]);
		shuffleInstance.update();
	},
	watch: {
		filtro: function () {
			// this.$globalEvent.$emit('slideSound');
			shuffleInstance.filter([this.filtro]);
			shuffleInstance.update();
		}
	}
}
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
.container {
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background-image: url("~@/assets/img/docentes_screen/background.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
.logo-cpe {
	position: fixed;
	right: 70px;
	top: 15px;
	width: 150px;
	max-width: 30%;
	opacity: 0.5;
}

.volver-container {
	z-index: 2;
	position: absolute;
	top: 0px;
	left: 0px;
	display: flex;
	flex-direction: row;
}

.volver-container > .planeta-volver {
	width: 150px;
	margin-left: -50px;
	@include mobile {
		width: 100px;
		margin-left: -40px;
	}
}

.volver-container > .planeta-volver > .planeta {
	filter: drop-shadow(0px 0px 10px white);
	cursor: url("~@/assets/img/cursors/pointer.png"), pointer;
	max-width: 100%;
	margin-top: -50px;
	@include mobile {
		margin-top: -40px;
	}
}

.planeta-volver > .tooltip {
	position: absolute;
	left: 90px;
	top: 60px;
	background-color: rgba(173, 192, 0, 1);
	color: white;
	opacity: 0;
	padding-left: 10px;
	padding-right: 10px;
	border-radius: 0px 10px 10px 10px;
	@include mobile {
		left: 50px;
		top: 40px;
	}
}

.planeta:hover + .tooltip {
	opacity: 1;
}

.volver-container > .titulo {
	color: white;
	padding: 0px 0px 0px 15px;
	text-align: left;
	@include mobile {
		font-size: 10pt;
	}
	@include mobile-s {
		font-size: 8pt;
	}
}

.volver-container > .titulo > h1 {
	margin: 0px;
	padding: 0px;
	text-shadow: 0px 0px 10px black;
}

.leyenda {
	color: white;
}

.apps-container {
	position: fixed;
	bottom: 50px;
	left: 25%;
	display: flex;
	align-items: flex-end;
}

// .observatorio {
// }

.observatorio-img {
	width: auto;
	max-width: 200px;
	height: auto;
	max-height: 200px;
}

.filtro {
	color: white;
}

.apps-lista {
	color: white;
	position: absolute;
	background-color: rgba(0, 0, 0, 0.5);
	bottom: 250px;
	max-height: 300px;
	overflow-y: auto;
	left: 75px;
	border-radius: 15px;
	// overflow: hidden;
}

.shuffle-lista {
	width: 400px;
}

.icono {
	width: 60px;
	height: 60px;
	border-radius: 15px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: white;
	min-width: 60px;
	cursor: url('~@/assets/img/cursors/pointer.png'), pointer;
	// flex-grow: 1;
}

.icono > img {
	width: auto;
	max-width: 100%;
	height: auto;
	max-height: 100%;
}

.texto {
	font-size: 15pt;
	margin: 10px;
	flex-grow: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 55%;
}

// .textoin {
// 	// text-overflow: ellipsis;
// }

// .botonguia {
// 	// flex-grow: 1;
// }

.app-item {
	width: 100%;
	white-space: nowrap;
	text-align: left;
	margin: 5px;
	margin-left: 15px;
	margin-right: 15px;
	display: flex;
	// justify-content: center;
	align-items: center;
}

.selectores {
	position: absolute;
	height: 100%;
	width: 100px;
	top: 0px;
	right: 0px;
	// background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: white;
}

.selector {
	margin-top: 10px;
	margin-bottom: 10px;
	cursor: url('~@/assets/img/cursors/pointer.png'), pointer;
}

.selector > .circulo {
	width: 80px;
	height: 80px;
	border-radius: 80px;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>

